module.exports = __webpack_public_path__ + "static/media/react.90f55145.jpg";